/* eslint-disable import/extensions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useMemo, useState } from 'react';
import { useCookies } from 'react-cookie';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';
import { SmlsAnimation } from '@smiles/smiles-ui-kit-react';
import { useAuth0 } from '@auth0/auth0-react';
import jwt from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';

import { loginLiferay } from 'utils/liferay';
import { getPartnerToken, saveTokenAuthUser } from 'services/core/services';

const CallbackApp: React.FC = () => {
  const JWT_COOKIE_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';

  const { isLoading } = useAuth0();
  const location = useLocation();
  const [animationState, setAnimationState] = useState({ isLoading: false, isSuccess: false });
  const [onFinishAnimation, setOnFinishAnimation] = useState<() => void>();
  const [cookies, setCookie, removeCookie] = useCookies([JWT_COOKIE_NAME]);
  const { t } = useTranslation('callback');
  const [message, setMessage] = useState({
    error: [],
    loading: [t('one_moment')],
    success: [t('ready')],
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState({ isLoading: true, isSuccess: true });
    }, 1050);

    return () => clearTimeout(timer);
  }, []);
  const params = useMemo(() => parse(location.search), [location]);
  const APP_SESSION_TOKEN = 'APP_SESSION_TOKEN';
  useEffect(() => {
    (async () => {
      if (isLoading) {
        return;
      }
      const urlToken = params.st as string;
      if (urlToken) {
        localStorage.setItem(APP_SESSION_TOKEN, urlToken);
      }
      // Prioriza o token vindo da URL (?st=...) ou usa o cookie/localStorage
      const token =
        (params.st as string) ||
        cookies[JWT_COOKIE_NAME] ||
        localStorage.getItem(JWT_COOKIE_NAME) ||
        localStorage.getItem(APP_SESSION_TOKEN) ||
        '';
      console.log('🚀 ~ CallbackApp ~ token:', token);
      if (!token) {
        setOnFinishAnimation(() => {
          console.error('--------------------missing auth token--------------------');
          let redirectUrl = `${window.location.origin}/home?upd=${new Date().getTime()}`;
          if (params.redir) {
            redirectUrl = params.redir as string;
          }
          window.location.href = redirectUrl;
        });
        setAnimationState({ isSuccess: false, isLoading: false });
        return;
      }

      // token data
      removeCookie(JWT_COOKIE_NAME);
      const decoded = jwt.decode(token) as any;

      // liferay 6.2 login
      const errorLoginLF = await loginLiferay(token, decoded);
      if (errorLoginLF) {
        return;
      }

      const product = params.product as string;
      console.log('🚀 ~ CallbackApp ~ product:', product);

      // // Se houver product, tenta gerar token e redirecionar para o parceiro
      if (product) {
        try {
          await saveTokenAuthUser(token);

          const ret = await getPartnerToken(product);
          console.log('🚀 ~ CallbackApp ~ ret:', ret);
          if (ret?.data?.dataToken?.redirectLogin) {
            let redirectLogin = ret.data.dataToken.redirectLogin;

            //       // anexa ?st=token
            redirectLogin += `${redirectLogin.includes('?') ? '&' : '?'}st=${token}`;
            console.log('🚀 ~ CallbackApp ~ redirectLogin:', redirectLogin);
            setOnFinishAnimation(() => {
              setTimeout(() => {
                window.location.href = redirectLogin;
              }, 3000);
            });
            setAnimationState({ isSuccess: true, isLoading: false });
            return;
          }
        } catch (e) {
          console.error('Erro ao gerar token para o parceiro', e);
        }
      }

      // fallback
      let redirectUrl = `${window.location.origin}/home?upd=${new Date().getTime()}`;
      if (params.redir) {
        redirectUrl = params.redir as string;
      }

      setOnFinishAnimation(() => {
        window.location.href = redirectUrl as string;
      });
      setAnimationState({ isSuccess: true, isLoading: false });
    })();
  }, [isLoading]);

  return <SmlsAnimation currentState={animationState} onExit={onFinishAnimation} message={message} finishMode="yes" />;
};

export default CallbackApp;
